import {
  LIST_MOTIVO_INIT,
  LIST_MOTIVO_SUCCESS,
  CREATE_MOTIVO_INIT,
  CREATE_MOTIVO_SUCCESS,
  UPDATE_MOTIVO_INIT,
  UPDATE_MOTIVO_SUCCESS,
  DELETE_MOTIVO_INIT,
  DELETE_MOTIVO_SUCCESS,
  MOTIVO_ERROR_MSG,
  CLEAR_MOTIVO
} from '../actionTypes';

const INIT_STATE: any = {
  loading: false,
  isCreated: false,
  isUpdated: false,
  isDeleted: false,
  isError: false,
  motivos: [],
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_MOTIVO_INIT:
      return { ...state, loading: true};
    case LIST_MOTIVO_SUCCESS: {
      const { motivos } = action.payload;
      return {
        ...state,
        motivos,
        loading: false
      };
    }
    case CREATE_MOTIVO_INIT:
      return {
        ...state,
        isCreated: false,
      };
    case CREATE_MOTIVO_SUCCESS: {
      const { msg, isCreated, motivo } = action.payload;
      return {
        ...state,
        motivos: state.motivos.concat(motivo),
        msg,
        isCreated,
      };
    }
    case UPDATE_MOTIVO_INIT:
      return {
        ...state,
        isUpdated: false
      };
    case UPDATE_MOTIVO_SUCCESS: {
      const { msg, isUpdated, motivo } = action.payload;
      return {
        ...state,
        motivos: state.motivos.map((m: any) => m.id === motivo.id ? motivo : m),
        msg,
        isUpdated,
      };
    }
    case DELETE_MOTIVO_INIT:
      return {
        ...state,
        isDeleted: false,
      };
    case DELETE_MOTIVO_SUCCESS: {
      const { msg, isDeleted, motivo } = action.payload;
      return {
        ...state,
        motivos: state.motivos.filter((m: any) => m.id !== motivo.id),
        msg,
        isDeleted,
      };
    }
    case MOTIVO_ERROR_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, isError: true, msg };
    }
    case CLEAR_MOTIVO: {
      return {
        ...state,
        isUpdated: false,
        isCreated: false,
        isDeleted: false,
        isError: false,
        loading: false,
        msg: ''
      };
    }
    default:
      return { ...state };
  }
};
